import React, { DependencyList, EffectCallback, MutableRefObject } from 'react';

const useUpdateEffect = (effect: EffectCallback, deps: DependencyList = []) => {
    const firstRun: MutableRefObject<boolean> = React.useRef(true);

    React.useEffect(() => {
        if (firstRun.current === true) {
            firstRun.current = false;
            return;
        }
        // eslint-disable-next-line consistent-return
        return effect();
    }, deps);
};

export default useUpdateEffect;
